export default __webpack_public_path__ + "static/media/patti.14ff5f5e.svg";